import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { Card } from "reactstrap";

export default function Datatable({ data, columns }) {
  const customStyles = {
    headRow: {
      style: {
        backgroundColor: "var(--bs-sidebar-menu-item-active-color)",
        fontWeight: "bold",
      },
    },
    headCells: {
      style: {
        color: "#fff",
        fontSize: "14px",
      },
    },  
  };

  return (
    <Card>
      <DataTable
        columns={columns}
        data={data}
        fixedHeader
        paginationPerPage={25}
        paginationRowsPerPageOptions={[25, 50, 100, 200, 300]}
        fixedHeaderScrollHeight="70vh"
        highlightOnHover
        pagination
        persistTableHead
        customStyles={customStyles} 
      />
    </Card>
  );
}
